import React from "react";
import '../styles/Banner.scss';

function Banner(props) {
    return <div className="banner">
        {props.text}
    </div>
}

export { Banner };